import React from 'react';
import Header from '../components/Header';
import { Mail, MessageCircle, Clock } from 'lucide-react';

const CONTACTS = [
  {
    icon: Mail,
    label: 'General Support',
    email: 'support@zuriya.co.uk',
    description: 'Booking issues, account help, general questions',
  },
  {
    icon: MessageCircle,
    label: 'Provider Support',
    email: 'providers@zuriya.co.uk',
    description: 'Onboarding, payouts, service listings, dashboard help',
  },
  {
    icon: Mail,
    label: 'Privacy & Data',
    email: 'privacy@zuriya.co.uk',
    description: 'Data requests, account deletion, GDPR enquiries',
  },
  {
    icon: Mail,
    label: 'Partnerships & Enquiries',
    email: 'hello@zuriya.co.uk',
    description: 'Collaborations, press, general enquiries',
  },
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-12">
        <div className="text-center mb-10">
          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-[#1A1A1A] mb-3" data-testid="contact-title">Contact Us</h1>
          <p className="text-stone-500 max-w-xl mx-auto">
            We'd love to hear from you. Whether you're a client, a provider, or just curious, reach out and we'll get back to you.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-10" data-testid="contact-cards">
          {CONTACTS.map((contact) => (
            <a
              key={contact.email}
              href={`mailto:${contact.email}`}
              className="card-surface p-6 card-hover group"
              data-testid={`contact-${contact.email.split('@')[0]}`}
            >
              <div className="w-10 h-10 rounded-full bg-[#F9F6F0] flex items-center justify-center mb-4 group-hover:bg-[#D4AF37]/10 transition-colors">
                <contact.icon className="h-5 w-5 text-[#D4AF37]" />
              </div>
              <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-1">{contact.label}</h3>
              <p className="text-[#D4AF37] text-sm font-medium mb-2">{contact.email}</p>
              <p className="text-xs text-stone-400">{contact.description}</p>
            </a>
          ))}
        </div>

        <div className="card-surface p-6 flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-[#F9F6F0] flex items-center justify-center flex-shrink-0">
            <Clock className="h-5 w-5 text-[#D4AF37]" />
          </div>
          <div>
            <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-1">Response Times</h3>
            <p className="text-sm text-stone-500">We aim to respond to all enquiries within 24 hours during business days (Monday–Friday, 9am–6pm GMT). Urgent booking issues are prioritised.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
